/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { CheckInComplianceDrillInModal } from "../check_in_compliance_drill_in_modal";
import { OrderNumberCell } from "../order_number_cell";
import { RenderDiscountCardsList } from "../render_discount_cards_list";
import camelize from "../../utils/camelize";
import { formatDate } from "../../utils/formatDate";

// Same columns as the Employee Perqs table.
const COLUMN_OPTIONS = [
  { key: "unique_id" },
  { key: "employee_name" },
  { key: "check_in_date" },
  { key: "order_number", label: "Order #" },
  { key: "order_details", label: "Order Details", sortable: false },
  { key: "order_date" },
  { key: "visiting_restaurant" },
  { key: "check_in_code" },
  { key: "discount_card_used", label: "Perq Card Used" },
  { key: "total_order_amount_before_discount", label: "Total Order Amount Before Perq" },
  { key: "discount", label: "Perq" },
  { key: "total_order_amount_after_discount", label: "Total Order Amount After Perq" },
];

const COLUMNS = COLUMN_OPTIONS.map((column) => ({
  key: column.key,
  label: column.label || camelize(column.key),
  sortable: column.sortable,
}));

const formatAmount = (amount) => (Number(amount) ? Number(amount) : 0).toFixed(2);

const buildRow = (record, onViewOrder) => ({
  unique_id: record?.network_guest?.phone_number,
  employee_name: `${record?.network_guest?.first_name} ${record?.network_guest?.last_name}`,
  check_in_date: formatDate(record?.check_in, record?.time_zone_abbr),
  order_number: record?.order?.order_no,
  order_details: <OrderNumberCell orderValue={record?.order} onView={onViewOrder} />,
  order_date: formatDate(record?.order?.opened, record?.time_zone_abbr),
  visiting_restaurant: record?.visiting_restaurant?.name,
  check_in_code: record?.discount_code,
  discount_card_used: {
    display: <RenderDiscountCardsList data={record?.discount_card ? [record?.discount_card] : []} />,
    sortValue: record?.discount_card?.name,
  },
  total_order_amount_before_discount: `$${formatAmount(Number(record?.total_discount || 0) + Number(record?.order?.total || 0))}`,
  discount: `$${formatAmount(record?.total_discount)}`,
  total_order_amount_after_discount: `$${formatAmount(record?.order?.total)}`,
});

// Lists the check-ins behind one Check-In Compliance row's Reconciled Check-Ins count, under the report's applied filters.
export const ReconciledCheckInModal = (props) => (
  <CheckInComplianceDrillInModal
    {...props}
    kind="reconciled_check_ins"
    title="Reconciled Check-Ins"
    testIdPrefix="reconciled-check-in-modal"
    columns={COLUMNS}
    buildRow={buildRow}
    type="check-ins"
    errorMessage="Failed to load reconciled check-ins."
  />
);
